import { TextField, Grid } from "@mui/material";
import React from "react";

import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";
import OnblurComponent from "../onBlur";

export default class GridModal {
  static DisplayTab(props) {
    const { onChange, onPropertieChange, state, classes } = props;
    const rows = getUnitPropertie(state, "rows") || 3;
    const columns = getUnitPropertie(state, "columns") || 3;

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => {
              const value = event.target.value;
              event.target.value = value <= 0 ? 1 : value > 50 ? 50 : value;
              onPropertieChange(event);
            }}
            name="rows"
            variant="outlined"
            id="standard-basic"
            label={language.propertieRows}
            value={rows}
            type="number"
            fullWidth
            helperText={language.toolTipRows}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => {
              const value = event.target.value;
              event.target.value = value <= 0 ? 1 : value > 12 ? 12 : value;
              onPropertieChange(event);
            }}
            name="columns"
            variant="outlined"
            id="standard-basic"
            label={language.propertieColumns}
            value={columns}
            type="number"
            fullWidth
            helperText={language.toolTipColumns}
          />
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    return <OnblurComponent {...props} />;
  }

  static StylesTab(props) {
    const { onPropertieChange, state, classes } = props;
    const propertieCSS = getUnitPropertie(state, "propertieCSS");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>
      </Grid>
    );
  }
}
